import { createCustomFilterForEntity } from "@shared/backend/create-custom-filter-for-entity";
import {
  filterWithRelationsAndJson,
  type RelationalOrJsonEntityFilter,
} from "@shared/helpers/sql-relations";
import { VolunteerOrgActivityDomain } from "./entity";

const createCustomFilter =
  createCustomFilterForEntity<VolunteerOrgActivityDomain>();

export class VolunteerOrgActivityDomainFilters {
  static hyperFilter = createCustomFilter<
    RelationalOrJsonEntityFilter<VolunteerOrgActivityDomain>
  >((filters) =>
    filterWithRelationsAndJson(VolunteerOrgActivityDomain)(filters),
  );
}
